import React, { useEffect, useState } from 'react';
import { createMobileStand, updateMobileStand } from '../services/mobileStandService';

const EMPTY_FORM = { name: '', location: '' };

export default function MobileStandForm({ mobileStand, onCancel, onSaved }) {
  const [form, setForm] = useState(EMPTY_FORM);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const isEditing = Boolean(mobileStand);

  useEffect(() => {
    if (mobileStand) {
      setForm({
        name: mobileStand.name || '',
        location: mobileStand.location || '',
      });
    } else {
      setForm(EMPTY_FORM);
    }
    setError('');
  }, [mobileStand]);

  function handleChange(field, value) {
    setForm(f => ({ ...f, [field]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setSaving(true);

    const payload = {
      name: form.name.trim(),
      location: form.location.trim(),
    };

    try {
      if (isEditing) {
        await updateMobileStand(mobileStand.id, payload);
      } else {
        await createMobileStand(payload);
      }
      onSaved();
    } catch (err) {
      const msg = err.response?.data?.msg || 'No se pudo guardar el stand móvil.';
      setError(msg);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: 'rgba(0,0,0,0.65)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="section-card"
        style={{ width: '100%', maxWidth: 560, marginBottom: 0, maxHeight: '90vh', overflowY: 'auto' }}
      >
      <div className="section-header">
        <h6>
          <i className={`bi ${isEditing ? 'bi-pencil-square' : 'bi-plus-circle'}`} style={{ color: 'var(--orig-green)' }} />
          {isEditing ? 'Editar Stand Móvil' : 'Nuevo Stand Móvil'}
        </h6>
        <button
          type="button"
          onClick={onCancel}
          style={{ background: 'none', border: 'none', color: 'var(--orig-text-muted)', fontSize: 18, cursor: 'pointer', lineHeight: 1 }}
          title="Cerrar"
        >
          ×
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="section-body">
          {error && (
            <div className="alert-orig alert-error" style={{ marginBottom: 16 }}>
              <i className="bi bi-exclamation-triangle-fill" />
              {error}
            </div>
          )}

          <div className="row g-3">
            <div className="col-12 col-md-6">
              <label className="form-label">Nombre</label>
              <input
                type="text"
                className="form-control"
                placeholder="Ej: Stand Plaza Central"
                value={form.name}
                onChange={e => handleChange('name', e.target.value)}
                required
              />
            </div>

            <div className="col-12 col-md-6">
              <label className="form-label">
                Ubicación <span style={{ opacity: 0.5, fontSize: '0.8em' }}>(opcional)</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Ej: Plaza Bolívar, frente a la alcaldía"
                value={form.location}
                onChange={e => handleChange('location', e.target.value)}
              />
            </div>
          </div>
        </div>

        <div style={{
          display: 'flex', justifyContent: 'flex-end', gap: 10,
          padding: '14px 20px', borderTop: '1px solid var(--orig-border)',
        }}>
          <button type="button" className="btn-orig btn-orig-outline" onClick={onCancel}>
            Cancelar
          </button>
          <button type="submit" className="btn-orig btn-orig-green" disabled={saving}>
            <i className="bi bi-check-lg" />
            {saving ? 'Guardando...' : isEditing ? 'Guardar cambios' : 'Crear Stand'}
          </button>
        </div>
      </form>
      </div>
    </div>
  );
}
